import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import Loadable from '../../base/components/Template/Loadable/Loadable'
import { rolesRoutesMap } from './RolesRoutesMap'

const AppRolesGestion = Loadable(
  lazy(() => import(/** esbuildChunkName: "lazyRoles" **/ './view/listado/Roles')),
)
const AppRolesNuevo = Loadable(
  lazy(
    () =>
      import(
        /** webpackChunkName: "lazyRolesRegistro" **/ './view/registro/RolesRegistro'
      ),
  ),
)
const AppRolesActualizar = Loadable(
  lazy(
    () =>
      import(
        /** webpackChunkName: "lazyRolesActualizar" **/ './view/actualizar/RolesActualizar'
      ),
  ),
)

const rolesRoutes = [
  {
    path: rolesRoutesMap.gestion.path,
    element: <AppRolesGestion />,
    auth: authRoles.admin,
  },
  {
    path: rolesRoutesMap.nuevo.path,
    element: <AppRolesNuevo />,
    auth: authRoles.admin,
  },
  {
    path: `${rolesRoutesMap.modificar.path}`,
    element: <AppRolesActualizar />,
    auth: authRoles.admin,
  },
]

export default rolesRoutes
